<script setup lang="ts">
import { ref, watch } from 'vue';

interface Props {
    show: boolean;
    message?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmValue?: string;
    cancelValue?: string;
}

const props = withDefaults(defineProps<Props>(), {
    message: 'Are you sure?',
    confirmLabel: 'Yes',
    cancelLabel: 'No',
    confirmValue: 'confirm',
    cancelValue: 'cancel',
});

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void;
    (e: 'confirm'): void;
    (e: 'cancel'): void;
}>();

const dialog = ref<HTMLDialogElement | null>(null);

watch(
    () => props.show,
    (newVal) => {
        if (newVal) {
            dialog.value?.showModal();
        } else {
            dialog.value?.close();
        }
    },
);

function handleClose(event: Event) {
    const target = event.target as HTMLDialogElement;
    const returnValue = target.returnValue;
    if (returnValue === props.confirmValue) {
        emit('confirm');
    } else {
        emit('cancel');
    }
    emit('update:show', false);
}
</script>

<template>
    <teleport to="body">
        <dialog ref="dialog" class="app-dialog" @close="handleClose">
            <div class="dialog-content">
                <form method="dialog">
                    <p>{{ message }}</p>
                    <button :value="confirmValue" class="confirm">{{ confirmLabel }}</button>
                    <button :value="cancelValue" class="cancel">{{ cancelLabel }}</button>
                </form>
            </div>
        </dialog>
    </teleport>
</template>
